import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import MatrixSlider from './MatrixSlider';
import MatrixWhy from '../response/MatrixWhy';
import SurveyAttachment from '../attachment/SurveyAttachment';
import * as Matrix from '../matrix/Matrix';
import SimpleLogicList from '../../survey_editor/preview/SimpleLogicList';

const MatrixSliderQuestion = props => {
  const {
    add_why,
    choices,
    id,
    inputNamer = matrixFieldName,
    isDisabled,
    logic,
    name,
    pages,
    rows,
    showLogic,
    _type,
    why_text,
    bipolar,
  } = props;

  const [height, setHeight] = useState('');

  useEffect(() => {
      sliderTableHeight()
  });

  let sliderTableHeight = () => {
    let questionLabel = $('.question_text')

    questionLabel.on("click", () => {
      setTimeout(() => {
        calculateTableHeight()
      }, 1);
  });
    calculateTableHeight();
  };

  let calculateTableHeight = () => {
    let choiceEleHeights = [];
    let sliderElements = $(".rc-slider-mark-text");

    sliderElements.each(function(){ choiceEleHeights.push($(this).height()) });
    let sortedColumnHeights = choiceEleHeights.sort(function(a, b) {  return a - b;  });
    let longestColumn = sortedColumnHeights[sortedColumnHeights.length - 1];

    setHeight(`${longestColumn + 30}px`);
  };


  return (
    <QuestionWrapper {...props}>
      <Matrix.Table>
        {rows.map((row, rowIndex) => (
          <Matrix.Body key={rowIndex}>
            <Matrix.Row
              based_on={row.based_on}
              id={row.id || row.name}
              text={row.text}
              comparison_text={row.comparison_text}
              other={row.other}
              questionId={id}
              questionName={name}
              height={height}
              bipolar={bipolar}
            >
              <td key={rowIndex}>
                <MatrixSlider
                  disabled={isDisabled}
                  name={`questions[${name}-${row.name}]`}
                  questionId={id}
                  rowIndex={rowIndex}
                  choices={choices}
                />
              </td>
              {showLogic && logic && logic.length ? (
                <td style={{ backgroundColor: 'white', paddingLeft: '1rem' }}>
                  <SimpleLogicList
                    logic={logic.filter(term => term.matrix_row_id === row.id)}
                    pages={pages}
                    showChoiceLabel={true}
                  />
                </td>
              ) : null}
            </Matrix.Row>
            <MatrixWhy
              add_why={add_why}
              colSpan={choices.length + 1}
              disabled={isDisabled}
              id={id}
              name={name}
              rowName={row.name}
              rowIndex={rowIndex}
              why_text={why_text}
            />
          </Matrix.Body>
        ))}
      </Matrix.Table>
    </QuestionWrapper>
  );
};

const matrixFieldName = (_type, name, rowName) =>
  _type === 'Survey::SingleSelect'
    ? `questions[${name}-${rowName}]`
    : `questions[${name}-${rowName}][]`;

MatrixSliderQuestion.propTypes = {
  _type: PropTypes.string,
  add_none: PropTypes.bool,
  add_dont_know: PropTypes.bool,
  add_other: PropTypes.bool,
  add_why: PropTypes.bool,
  choices: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  ranking: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.array.isRequired,
  text: PropTypes.string.isRequired,
  why_text: PropTypes.string,
};

export default MatrixSliderQuestion;
